import ContractsList from './ContractsList';

export default ContractsList;
